// extracted by mini-css-extract-plugin
module.exports = {"root":"Divider_root__88VLN","content":"Divider_content__hN0M8"};